import * as React from 'react';
import * as _ from 'lodash';
import { CheckBox } from 'shared_components';
import { PARTS } from './../../../schemas/accessRightsModel';
export default function () {
    function onChange1(AR, e) {
        AR.e(PARTS.STONE_SETUP_EDIT_PRICE) && this.onChange('price', e.target.value);
    }
    function onBlur2(AR, e) {
        AR.e(PARTS.STONE_SETUP_EDIT_PRICE) && this.updatePriceTransientfield(e.target.value);
    }
    function onChange3(AR, e) {
        AR.e(PARTS.STONE_SETUP_EDIT_PRICE) && this.onChange('slabSqftOverridePrice', e.target.value);
    }
    function onBlur4(AR, e) {
        AR.e(PARTS.STONE_SETUP_EDIT_PRICE) && this.updateSlabSqftOverridePriceTransientfield(e.target.value);
    }
    function scopeAR5() {
        var AR = this.props.AR;
        return React.createElement('li', { 'className': 'assign-list__item' }, React.createElement('div', { 'className': 'assign-card' }, React.createElement('div', { 'className': 'assign-card__checkbox' }, React.createElement(CheckBox, {
            'onChecked': this.toggleSelection,
            'checked': this.props.isSelected,
            'innerStyle': 'grey',
            'text': true
        })), React.createElement('div', {
            'className': 'assign-card__image',
            'style': { backgroundImage: 'url(' + this.getStoneImage() + ')' }
        }), this.isAssignedPricingProfile() ? React.createElement('div', {
            'className': 'assign-card__icon',
            'style': { backgroundImage: 'url(' + this.getPricingProfileIcon() + ')' },
            'key': '615'
        }) : null, !this.isAssignedPricingProfile() || this.shouldShowPriceAnyway() ? React.createElement('div', {
            'className': _.transform({
                'stone-price-frame': true,
                'assign-card__slab': this.props.hasSlabModeEnabled && this.isAssignedPricingSlab()
            }, function (res, value, key) {
                if (value) {
                    res.push(key);
                }
            }, []).join(' '),
            'key': '764'
        }, React.createElement('div', { 'className': 'stone-price-text-outline' }), React.createElement('input', {
            'tooltip': this.isAssignedPricingSlab() ? 'Slab Price' : 'Price',
            'className': 'stone-price-text',
            'placeholder': 'Enter Price',
            'value': this.state.price,
            'readOnly': true,
            'onChange': onChange1.bind(this, AR),
            'onBlur': onBlur2.bind(this, AR)
        })) : null, this.props.hasSlabModeEnabled && this.isAssignedPricingSlab() && (!this.isAssignedPricingProfile() || this.shouldShowPriceAnyway()) ? React.createElement('div', {
            'className': 'stone-price-frame assign-card__slab assign-card__slab_sqft',
            'key': '1616'
        }, React.createElement('div', { 'className': 'stone-price-text-outline' }), this.isAssignedPricingSlab() ? React.createElement('input', {
            'tooltip': 'SQFT Price',
            'className': 'assign-card__slab stone-price-text',
            'placeholder': 'Enter Price',
            'value': this.state.slabSqftOverridePrice,
            'readOnly': !AR.e(PARTS.STONE_SETUP_EDIT_PRICE),
            'onChange': onChange3.bind(this, AR),
            'onBlur': onBlur4.bind(this, AR),
            'key': '1913'
        }) : null) : null, React.createElement('div', { 'className': 'assign-card__title' }, this.getStoneName())));
    }
    return scopeAR5.apply(this, []);
}